export const executionMethodTypes = {
    noInformation:"noInformation",
    localIntervention:"localIntervention",
    remoteIntervention:"remoteIntervention",
    customerIntervention:"customerIntervention"
};